import styled from "styled-components";

export const EmptyStateContainer = styled.div`
  margin: 3rem 0;
`;

export const Header = styled.h4`
  padding: 0.5rem 1rem;
`;

export const RecentListItemContent = styled.div`
  display: flex;
  align-items: flex-start;
`;
